import script from "./AdminSideBar.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminSideBar.vue?vue&type=script&setup=true&lang=js"

import "./AdminSideBar.vue?vue&type=style&index=0&id=840b84d0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-840b84d0"]])

export default __exports__